import React from 'react';
import { Link } from 'react-router-dom';
import { getOptimizedImageUrl } from '../lib/cms';

export default function CtaSection({
  title = "Klar til at styrke din virksomheds synlighed?",
  subtitle = "Få løbende sparring, professionel redigering og en skarp postkalender. Ingen faste prispakker, 0 binding, og benyt vores tilbud: betal for 2 mdr. og få 1 mdr. gratis.",
  primaryButtonText = "Kontakt os for en uforpligtende snak",
  primaryButtonLink = "/kontakt",
  secondaryButtonText = null,
  secondaryButtonLink = "/ydelser",
  backgroundImage = "https://assets.auxodev.dk/assets/d61c94bc-c5ec-439d-a220-afcc00eef7a0/production-editing-studio.png"
}) {
  return (
    <section className="relative py-20 lg:py-28 overflow-hidden bg-[#161514] text-[#FAF8F5]">
      {/* Background image with high-end dark gradient overlay */}
      {backgroundImage && (
        <div className="absolute inset-0 z-0">
          <img
            src={getOptimizedImageUrl(backgroundImage, { width: 1920, quality: 80, format: 'auto' })}
            alt="Professionel service"
            className="w-full h-full object-cover opacity-60 object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#161514]/70 via-[#161514]/45 to-[#161514]/75" />
          <div className="absolute inset-0 bg-radial from-transparent via-[#161514]/25 to-[#161514]/50" />
        </div>
      )}

      {/* Subtle ambient light */}
      <div className="absolute inset-0 bg-radial from-[#C5A880]/10 via-transparent to-transparent pointer-events-none z-1" />
      
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white max-w-3xl mx-auto leading-tight">
          {typeof title === 'string' && title.includes('ud af dine ') ? (
            title.split('ud af dine ').map((part, index, arr) => (
              <span key={index}>
                {part}
                {index < arr.length - 1 && (
                  <>
                    ud af dine
                    <br className="hidden sm:inline" />{' '}
                  </>
                )}
              </span>
            ))
          ) : (
            title
          )}
        </h2>

        <p className="text-base sm:text-lg text-[#C7C0B5] max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={primaryButtonLink}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#FAF8F5] text-[#161514] font-semibold text-base hover:bg-[#EFEAE2] active:scale-98 transition-all shadow-lg"
          >
            <span>{primaryButtonText}</span>
            <i className="fa-regular fa-arrow-right text-sm" aria-hidden="true" />
          </Link>

          {secondaryButtonText && (
            <Link
              to={secondaryButtonLink}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-white/20 text-white font-medium text-base hover:bg-white/10 transition-colors"
            >
              <span>{secondaryButtonText}</span>
            </Link>
          )}
        </div>

        <div className="pt-6 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto text-xs text-white border-t border-white/30">
          <div className="flex items-center justify-center gap-2">
            <i className="fa-light fa-circle-check text-[#C5A880] text-sm" aria-hidden="true" />
            <span>Sparring, redigering & synlighed</span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <i className="fa-light fa-circle-check text-[#C5A880] text-sm" aria-hidden="true" />
            <span>0 binding · Fleksible aftaler</span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <i className="fa-light fa-circle-check text-[#C5A880] text-sm" aria-hidden="true" />
            <span>Betal 2 mdr – få 1 gratis</span>
          </div>
        </div>
      </div>
    </section>
  );
}
